import React from 'react';
interface DataPoint {
  value: number;
  label: string;
}
interface LineChartProps {
  data: DataPoint[];
  height?: number;
  color?: string;
  showLabels?: boolean;
  showGrid?: boolean;
  animated?: boolean;
  darkMode?: boolean;
}
export function LineChart({
  data,
  height = 100,
  color = '#3b82f6',
  showLabels = true,
  showGrid = true,
  animated = true,
  darkMode = false
}: LineChartProps) {
  if (!data || data.length === 0) return null;
  const values = data.map(d => d.value);
  const max = Math.max(...values) * 1.1;
  const min = Math.min(...values) * 0.9;
  // Create points for the path
  const points = data.map((d, i) => {
    const x = i / (data.length - 1) * 100;
    const y = 100 - (d.value - min) / (max - min) * 100;
    return `${x},${y}`;
  });
  const pathD = `M${points.join(' L')}`;
  const textColor = darkMode ? 'text-gray-300' : 'text-gray-600';
  const gridColor = darkMode ? 'stroke-gray-700' : 'stroke-gray-200';
  const labelColor = darkMode ? 'text-gray-400' : 'text-gray-500';
  const bgColor = darkMode ? 'bg-gray-900' : 'bg-white';
  return <div className={`relative ${bgColor} rounded-lg p-4 w-full`} style={{
    height: `${height}px`
  }} data-id="element-41">
      <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-42">
        {/* Grid lines */}
        {showGrid && <>
            <line x1="0" y1="0" x2="100" y2="0" className={`${gridColor} stroke-1`} data-id="element-43" />
            <line x1="0" y1="25" x2="100" y2="25" className={`${gridColor} stroke-1`} data-id="element-44" />
            <line x1="0" y1="50" x2="100" y2="50" className={`${gridColor} stroke-1`} data-id="element-45" />
            <line x1="0" y1="75" x2="100" y2="75" className={`${gridColor} stroke-1`} data-id="element-46" />
            <line x1="0" y1="100" x2="100" y2="100" className={`${gridColor} stroke-1`} data-id="element-47" />
          </>}
        {/* Line */}
        <path d={pathD} fill="none" stroke={color} strokeWidth="2" className={animated ? 'animate-dash' : ''} strokeDasharray={animated ? '1000' : '0'} strokeDashoffset={animated ? '1000' : '0'} style={animated ? {
        animation: 'dash 1.5s linear forwards'
      } : {}} data-id="element-48" />
        {/* Area under the line */}
        <path d={`${pathD} L100,100 L0,100 Z`} fill={color} fillOpacity="0.1" data-id="element-49" />
        {/* Data points */}
        {data.map((d, i) => {
        const x = i / (data.length - 1) * 100;
        const y = 100 - (d.value - min) / (max - min) * 100;
        return <circle key={i} cx={x} cy={y} r="1.5" fill={color} className={animated ? 'animate-pulse' : ''} data-id="element-50" />;
      })}
      </svg>
      {/* Labels */}
      {showLabels && <div className="absolute bottom-0 left-0 right-0 flex justify-between px-2" data-id="element-51">
          {data.filter((_, i) => i % Math.ceil(data.length / 5) === 0 || i === data.length - 1).map((d, i) => <span key={i} className={`text-xs ${labelColor}`} data-id="element-52">
                {d.label}
              </span>)}
        </div>}
    </div>;
}